import { useState } from "react";
import {
  RiAddLine,
  RiMailLine,
  RiWhatsappLine,
  RiDeleteBin6Line,
} from "react-icons/ri";

const CustomTriggers = () => {
  const [triggers, setTriggers] = useState([
    {
      id: 1,
      type: "link_click",
      linkPattern: "/product/*",
      action: {
        type: "email",
        template: "product_details",
        delay: 24,
      },
    },
  ]);

  const addTrigger = () => {
    setTriggers([
      ...triggers,
      {
        id: Date.now(),
        type: "link_click",
        linkPattern: "",
        action: {
          type: "email",
          template: "",
          delay: 24,
        },
      },
    ]);
  };

  const deleteTrigger = (id) => {
    setTriggers(triggers.filter((trigger) => trigger.id !== id));
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-secondary-900">
          Custom Triggers
        </h3>
        <button
          className="btn btn-secondary flex items-center"
          onClick={addTrigger}
        >
          <RiAddLine className="w-5 h-5 mr-2" />
          Add Trigger
        </button>
      </div>

      <div className="space-y-4">
        {triggers.map((trigger) => (
          <div key={trigger.id} className="card border-2 border-dashed">
            <div className="flex justify-between items-start">
              <div className="space-y-4 flex-1">
                <div>
                  <label className="label">Trigger Type</label>
                  <select
                    className="input-field"
                    value={trigger.type}
                    onChange={(e) => {
                      const updated = triggers.map((t) =>
                        t.id === trigger.id
                          ? { ...t, type: e.target.value }
                          : t,
                      );
                      setTriggers(updated);
                    }}
                  >
                    <option value="link_click">Link Click</option>
                    <option value="email_open">Email Open</option>
                    <option value="no_open">No Open</option>
                  </select>
                </div>

                <div>
                  <label className="label">Link Pattern</label>
                  <input
                    type="text"
                    className="input-field"
                    placeholder="e.g., /product/*, /checkout/*"
                    value={trigger.linkPattern}
                    onChange={(e) => {
                      const updated = triggers.map((t) =>
                        t.id === trigger.id
                          ? { ...t, linkPattern: e.target.value }
                          : t,
                      );
                      setTriggers(updated);
                    }}
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="label">Action Type</label>
                    <div className="flex space-x-2">
                      <button
                        className={`btn flex items-center ${
                          trigger.action.type === "email"
                            ? "btn-primary"
                            : "btn-secondary"
                        }`}
                        onClick={() => {
                          const updated = triggers.map((t) =>
                            t.id === trigger.id
                              ? { ...t, action: { ...t.action, type: "email" } }
                              : t,
                          );
                          setTriggers(updated);
                        }}
                      >
                        <RiMailLine className="w-5 h-5 mr-2" />
                        Email
                      </button>
                      <button
                        className={`btn flex items-center ${
                          trigger.action.type === "whatsapp"
                            ? "btn-primary"
                            : "btn-secondary"
                        }`}
                        onClick={() => {
                          const updated = triggers.map((t) =>
                            t.id === trigger.id
                              ? {
                                  ...t,
                                  action: { ...t.action, type: "whatsapp" },
                                }
                              : t,
                          );
                          setTriggers(updated);
                        }}
                      >
                        <RiWhatsappLine className="w-5 h-5 mr-2" />
                        WhatsApp
                      </button>
                    </div>
                  </div>

                  <div>
                    <label className="label">Delay (hours)</label>
                    <input
                      type="number"
                      className="input-field"
                      value={trigger.action.delay}
                      onChange={(e) => {
                        const updated = triggers.map((t) =>
                          t.id === trigger.id
                            ? {
                                ...t,
                                action: {
                                  ...t.action,
                                  delay: parseInt(e.target.value),
                                },
                              }
                            : t,
                        );
                        setTriggers(updated);
                      }}
                    />
                  </div>
                </div>
              </div>

              <button
                className="text-danger-500 hover:text-danger-600 p-2"
                onClick={() => deleteTrigger(trigger.id)}
              >
                <RiDeleteBin6Line className="w-5 h-5" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomTriggers;
